<small class="debug">{{me}}</small>
<div style="width: 100%; height: 150px">
  @if (_ready && !showServers) {
    <div class="chartContainer" style="width: 100%; height: 100%">
      <highcharts-chart style="display: flex;" [callbackFunction]="chartCallback" [Highcharts]="Highcharts" [options]="chartOptions" (chartInstance)="logChartInstance($event)"></highcharts-chart>
    </div>
  }
  @if (_ready && showServers) {
    <div class="chartContainer" style="width: 100%; height: 100%; position: relative; top: 46px">
      <ngx-charts-bar-vertical style="fill: grey" [scheme]="colorScheme"
        [legend]="legend"
        [showXAxisLabel]="showXAxisLabel"
        [showYAxisLabel]="showYAxisLabel"
        [xAxis]="xAxis"
        [yAxis]="yAxis"
        [xAxisLabel]="xAxisLabel"
        [yAxisLabel]="yAxisLabel"
        [results]="chartDataServers"
        (select)="onSelect($event)">
      </ngx-charts-bar-vertical>
      <!--        <ngx-charts-line-chart-->
      <!--            [scheme]="colorScheme"-->
      <!--            [legend]="legend"-->
      <!--            [showXAxisLabel]="showXAxisLabel"-->
      <!--            [showYAxisLabel]="showYAxisLabel"-->
      <!--            [xAxis]="xAxis"-->
      <!--            [yAxis]="yAxis"-->
      <!--            [xAxisLabel]="xAxisLabel"-->
      <!--            [yAxisLabel]="yAxisLabel"-->
      <!--            [results]="chartData"-->
      <!--            (select)="onSelect($event)">-->
    <!--        </ngx-charts-line-chart>-->
  </div>
}
@if (!_ready) {
  <div>
    <app-loading [@fadeInOutAnimation] [size]="'50px'" [style]="{'margin-top': '50px'}"></app-loading>
  </div>
}
</div>
